import { FieldType, Operator } from '../../../../../../../services/common/Constants';
import React from 'react';
import EqualValue from './EqualValue';
import ContainsValue from './ContainsValue';
import NullValue from './NullValue';
import SetValue from './SetValue';
import DateCriterionValue from '../dateCriterionValue';

const TextValue = ({
  selectedOperator,
  selectedFieldSubType,
  fieldName,
  showLabel,
  availableValueOptions,
  variantAutoComplete,
  readOnly = false
}) => {
  if (selectedFieldSubType === FieldType.DATE) {
    return (
      <DateCriterionValue
        selectedOperator={selectedOperator}
        fieldName={fieldName}
        showLabel={showLabel}
        readOnly={readOnly}
      />
    )
  } else {
    switch (selectedOperator) {
      case Operator.EQUAL:
      case Operator.NOT_EQUAL:
        return (
          <EqualValue
            fieldName={fieldName}
            showLabel={showLabel}
            variantAutoComplete={variantAutoComplete}
            availableValueOptions={availableValueOptions}
            readOnly={readOnly}
          />
        );
      case Operator.CONTAINS:
      case Operator.NOT_CONTAINS:
      case Operator.STARTS_WITH:
      case Operator.NOT_STARTS_WITH:
      case Operator.ENDS_WITH:
      case Operator.NOT_ENDS_WITH:
        return <ContainsValue showLabel={showLabel} fieldName={fieldName} readOnly={readOnly}/>;
      case Operator.IS_NULL:
      case Operator.NOT_NULL:
        return <NullValue/>;
      case Operator.IN_SET:
      case Operator.NOT_IN_SET:
        return <SetValue
          fieldName={fieldName}
          showLabel={showLabel}
          variantAutoComplete={variantAutoComplete}
          availableValueOptions={availableValueOptions}
          readOnly={readOnly}
        />;
      default:
        return <></>;
    }
  }
};

export default TextValue;
